import { render } from "./SingleNews.vue?vue&type=template&id=ab8e160a&scoped=true&ts=true"
import script from "./SingleNews.vue?vue&type=script&lang=ts"
export * from "./SingleNews.vue?vue&type=script&lang=ts"

import "./SingleNews.vue?vue&type=style&index=0&id=ab8e160a&lang=scss"
import "./SingleNews.vue?vue&type=style&index=1&id=ab8e160a&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8e160a"]])

export default __exports__